import { logout, logoutUser } from "store/actions";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useNavigate } from "react-router-dom";
import { userDetailState } from "store/selectors";

const IDLE_TIMEOUT = 15 * 60 * 1000; // 15 minutes
const CHECK_INTERVAL = 60 * 1000; // Check every 1 minute

export function useIdleTimeout() {
  const dispatch = useAppDispatch();
  const { userDetail } = useAppSelector(userDetailState);
  const [isIdle, setIsIdle] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const resetTimer = () => {
      localStorage.setItem("last-activity", Date.now().toString());
      setIsIdle(false);
    };

    const handleUserActivity = () => resetTimer();

    // Set last activity time when the component mounts
    resetTimer();

    // Listen for user activity
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keypress", handleUserActivity);
    window.addEventListener("click", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);

    const interval = setInterval(() => {
      const lastActivity = parseInt(
        localStorage.getItem("last-activity") || "0"
      );
      const now = Date.now();

      if (now - lastActivity > IDLE_TIMEOUT) {
        setIsIdle(true);
        handleLogout();
      }
    }, CHECK_INTERVAL);

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keypress", handleUserActivity);
      window.removeEventListener("click", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
    };
  }, [navigate]);

  async function handleLogout() {
    const action = await dispatch(logoutUser({ ...userDetail }));
    if (action.payload.success) {
      localStorage.removeItem("user-detail");
      dispatch(logout());
      dispatch({ type: "LOGOUT" });
      navigate("/login"); // Redirect to login page
    }
  }

  return { isIdle };
}
